module.exports = __webpack_public_path__ + "static/media/img_3.477c1fb8.png";